export default __webpack_public_path__ + "static/media/IMG_6807.842e2be3.jpg";